import React from 'react';
import PropTypes from 'prop-types';
import RowIconTitleCaptionButtonSectionItem from './RowIconTitleCaptionButtonSectionItem';
import parse from 'html-react-parser';

const RowIconTitleCaptionButtonSection = ({
  header, items, backgroundDesktop, backgroundColor, backgroundPosition, containerClasses, headerClasses
}) => {
  const hasBackgroundImage = backgroundDesktop?.url?.length > 0;
  const backgroundImageStyles = hasBackgroundImage ? {
    '--background-image-mobile': `url(${backgroundDesktop.url})`,
    '--background-image-desktop': `url(${backgroundDesktop.url})`,
    backgroundImage: 'var(--background-image-desktop)',
    backgroundPosition: backgroundPosition || 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  } : {};
  return (
    <div
      className={`text-center lg:text-left px-8 py-14 md:px-24 xl:px-36
        2xl:px-60 lg:py-12 w-full ${containerClasses}`}
      style={{ ...backgroundImageStyles, ...(!hasBackgroundImage && backgroundColor ? { backgroundColor } : {}) }}
    >
      {header && header.length > 0 && (
        <h2 className={`text-4xl font-bold mb-10 ${headerClasses || ''}`}>{parse(header)}</h2>
      )}
      <div className="flex flex-col gap-11 lg:flex-row justify-between items-center max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((item, index) => (
            <RowIconTitleCaptionButtonSectionItem
              key={index} imageSrc={item.image.url}
              header={item.header}
              headerClasses={item.headerClasses}
              body={item.body}
              bodyClasses={item.bodyClasses}
              linkUrl={item.linkUrl}
              linkText={item.linkText}
              linkCustomClasses={item.linkCustomClasses}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

RowIconTitleCaptionButtonSection.propTypes = {
  header: PropTypes.string,
  headerClasses: PropTypes.string,
  containerClasses: PropTypes.string,
  backgroundDesktop: PropTypes.shape({
        url: PropTypes.string.isRequired
      }),
  backgroundColor: PropTypes.string,
  backgroundPosition: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }).isRequired,
      header: PropTypes.string,
      headerClasses: PropTypes.string,
      body: PropTypes.string,
    })
    
  ),
};

export default RowIconTitleCaptionButtonSection;
